import { Article, WithContext } from 'schema-dts';
import { useArticleAuthorJsonld } from '@experience/head/json-ld/use-author-jsonld';
import { useExperienceBaseJsonLD } from '@experience/head/json-ld/use-experience-base-jsonld';
import { FC } from 'react';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const ArticleJsonLD: FC = () => {
  const articleBaseJsonLD = useExperienceBaseJsonLD();
  const authorJsonLD = useArticleAuthorJsonld();

  if (!articleBaseJsonLD) {
    return null;
  }

  const articleJsonLd: WithContext<Article> = {
    '@context': 'https://schema.org',
    ...articleBaseJsonLD,
  };

  if (authorJsonLD) {
    articleJsonLd.author = authorJsonLD;
  }

  return (
    <DynamicHead>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }} />
    </DynamicHead>
  );
};
